/**
 *
 * @param {*}  获取url链接上?拼接的参数
 * @returns
 */
export const getUrlParams = () => {
    const { search, hash } = window.location;
    const searchParams = getStringParams(search);
    const hashParams = getStringParams(hash);
    return {
        ...searchParams,
        ...hashParams,
    };
};
/**
 *
 * @param {*} string 任意字符串?后面拼接的参数
 * @returns
 */
export const getStringParams = (string) => {
    if (!string) return {};
    const urlArr = string.split("?");
    if (urlArr.length === 1) return {};
    const obj = {};
    urlArr.forEach((item) => {
        const itemArr = item.split("&");
        itemArr.forEach((element) => {
            const [k, v] = element.split("=");
            v && (obj[k] = v);
        });
    });
    return obj;
};